import Layout from "@/components/Layout";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <section className="py-16 lg:py-20" id="privacy-policy">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-8">
            <div className="text-center space-y-4">
              <h1 className="text-4xl lg:text-5xl font-bold text-foreground">
                Privacy Policy
              </h1>
              <p className="text-muted-foreground">
                Last updated: 26 September, 2025.
              </p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  1. Information We Collect
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    We collect information you provide directly to us, such as
                    when you create an account, register for training programs,
                    contact us, or use our services.
                  </p>
                  <p>
                    <strong>Personal Information:</strong> Name, email address,
                    phone number, organization, job title, and other contact
                    information.
                  </p>
                  <p>
                    <strong>Training Information:</strong> Program preferences,
                    learning progress, assessment results, and feedback.
                  </p>
                  <p>
                    <strong>Technical Information:</strong> IP address, browser
                    type, device information, and usage data collected through
                    cookies and similar technologies.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  2. How We Use Your Information
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>We use the information we collect to:</p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>
                      Provide, maintain, and improve our training services
                    </li>
                    <li>Process registrations and deliver training programs</li>
                    <li>Communicate with you about our services and updates</li>
                    <li>Personalize your learning experience</li>
                    <li>Analyze usage patterns to improve our offerings</li>
                    <li>Comply with legal obligations</li>
                  </ul>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  3. Information Sharing
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    We do not sell, trade, or otherwise transfer your personal
                    information to third parties without your consent, except as
                    described in this policy:
                  </p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>
                      With service providers who assist us in operating our
                      business
                    </li>
                    <li>
                      With your employer or sponsoring organization (for
                      corporate training)
                    </li>
                    <li>When required by law or to protect our rights</li>
                    <li>In connection with a business transfer or merger</li>
                  </ul>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  4. Data Security
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    We implement appropriate technical and organizational
                    measures to protect your personal information against
                    unauthorized access, alteration, disclosure, or destruction.
                  </p>
                  <p>
                    However, no method of transmission over the Internet or
                    electronic storage is 100% secure. While we strive to
                    protect your information, we cannot guarantee absolute
                    security.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  5. Your Rights
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>You have the right to:</p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Access and update your personal information</li>
                    <li>Request deletion of your personal information</li>
                    <li>Object to processing of your personal information</li>
                    <li>Request data portability</li>
                    <li>
                      Withdraw consent where processing is based on consent
                    </li>
                  </ul>
                  <p>
                    To exercise these rights, please contact us at
                    info@tcla-x.com.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  6. Cookies and Tracking
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    We use cookies and similar tracking technologies to enhance
                    your experience on our website. You can control cookie
                    settings through your browser preferences.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  7. Changes to This Policy
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    We may update this Privacy Policy from time to time. We will
                    notify you of any material changes by posting the new policy
                    on our website and updating the "Last updated" date.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-foreground">
                  8. Contact Us
                </h2>
                <div className="space-y-3 text-muted-foreground">
                  <p>
                    If you have any questions about this Privacy Policy, please
                    contact us at:
                  </p>
                  <div className="bg-muted/30 p-4 rounded-lg">
                    <p>
                      <strong>TCLA-X Limited</strong>
                    </p>
                    <p>Email: info@tcla-x.com</p>
                    <p>Phone: +254722 319 499</p>
                    <p>Address: Nairobi, Kenya</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;
